var _defs, _path, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgExternalResource(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 3.704 3.704",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "external-resource_svg__a",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h12.08v12.044H0z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "external-resource_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h9.82v9.804H0z"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.022 12.03c-.98 0-1.96.025-2.94-.007-1.626-.051-3.024-1.432-3.055-3.06a159.559 159.559 0 010-5.875C.057 1.456 1.439.083 3.077.024 4.138-.014 5.2.004 6.263.008c.469.002.799.332.79.754-.009.427-.345.738-.809.74-.964.002-1.927-.001-2.89.001-1.047.003-1.805.728-1.813 1.774-.013 1.819-.013 3.638 0 5.458.007 1.039.742 1.769 1.784 1.775 1.813.011 3.626.012 5.439 0 1.048-.007 1.776-.756 1.781-1.803.005-.97-.001-1.941.003-2.912.002-.373.226-.679.54-.763.346-.092.694.036.864.348.07.13.116.292.117.44.01.995.02 1.99.001 2.986-.034 1.79-1.385 3.165-3.18 3.223-.955.031-1.911.006-2.867.006v-.006",
    fill: "#231f20",
    mask: "url(#external-resource_svg__a)",
    transform: "matrix(.26458 0 0 .26458 .002 .518)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M7.205 1.517c-.154-.008-.24-.016-.325-.016-.653-.001-1.307.002-1.96-.002-.507-.003-.845-.309-.843-.752.002-.44.346-.745.851-.745C6.276 0 7.623-.001 8.97.002c.554 0 .848.293.848.846.003 1.37.004 2.741-.001 4.112-.001.397-.257.699-.624.767a.737.737 0 01-.811-.45 1.187 1.187 0 01-.062-.406c-.006-.645-.003-1.29-.004-1.934 0-.085-.008-.171-.015-.325-.115.106-.186.166-.251.231C5.83 5.055 3.615 7.27 1.39 9.473a1.228 1.228 0 01-.556.313C.517 9.859.256 9.705.1 9.42a.712.712 0 01.053-.805c.066-.092.152-.17.232-.25l6.59-6.598c.064-.065.124-.136.23-.25",
    fill: "#231f20",
    mask: "url(#external-resource_svg__b)",
    transform: "matrix(.26458 0 0 .26458 1.108 0)"
  }))));
}

export default SvgExternalResource;